import { FC, useEffect, ReactNode } from 'react';
import { useDispatch } from 'react-redux';

import { getUser } from 'logic/store/authentication/actions';
import { getSsoConfig } from 'logic/store/sso/actions';

interface Props {
  children: (args: any) => ReactNode | ReactNode;
}

export const CheckUser: FC<Props> = ({ children, ...props }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUser());
    dispatch(getSsoConfig());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return typeof children === 'function' ? children({ ...props }) : children;
};

export default CheckUser;
